import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export type ProgressUpdate = (percent: number) => void;

export interface MessageDialogData {
  headerInfo: string;
  icon: string
  message: string;
  buttons: MessageBoxCustomButton;
  showNummericInput: boolean;
  showNummericHeader: boolean;
  nummericValue:number;
  nummericHeader:string;
  minValue: number;
  maxValue: number;
  stepSize: number;
  disableClose: boolean;
  showIndeterminateProgress: boolean;
  registerProgress?: (update: ProgressUpdate) => void;
}

export enum MessageBoxCustomButton {
  None = 0,
  OK = 1,
  Cancel = 2,
  Yes = 4,
  No = 8,
  OKCancel = OK | Cancel,
  YesNo = Yes | No,
  YesNoCancel = Yes | No | Cancel,
}

@Component({
  selector: 'app-message-dialog',
  templateUrl: './message-dialog.component.html',
  styleUrls: ['./message-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageDialogComponent implements OnInit {

   public headerInfo: string = "";
   public message: string = "";
   public buttons: MessageBoxCustomButton = MessageBoxCustomButton.None;
   public showNummericInput: boolean = false;
   public nummericValue: number = 1;
   public nummericHeader: string = "";
   public minValue: number = 0;
   public maxValue: number = 2000;
   public stepSize: number = 0;
   public showProgress: boolean = false;
   public progress: number = 0;
   public showIndeterminateProgress: boolean = false;

   public get MessageBoxCustomButton(): typeof MessageBoxCustomButton {
    return MessageBoxCustomButton;
  }

  constructor(
    public dialogRef: MatDialogRef<MessageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MessageDialogData,
    private cdr: ChangeDetectorRef,
  ) {
    this.headerInfo = data.headerInfo;
    this.message = data.message;
    this.buttons = data.buttons;
    this.showNummericInput = data.showNummericInput;
    this.nummericHeader = data.nummericHeader;
    this.nummericValue = data.nummericValue;
    this.minValue = data.minValue;
    this.maxValue = data.maxValue;
    this.stepSize = data.stepSize;
    this.showIndeterminateProgress = data.showIndeterminateProgress;

    if (data.registerProgress) {
      this.showProgress = true;
      data.registerProgress((percent) => {
        this.progress = percent;
        this.cdr.markForCheck();
      });
    }

    // don't block the user interfac when the buttons is of type None
    if (this.buttons !== MessageBoxCustomButton.None) {
      dialogRef.disableClose = true;
    }

    if (data.disableClose !== undefined) {
      dialogRef.disableClose = data.disableClose;
    }
  }

  public ngOnInit(): void {
  }

  public onNoClick(): void {
    this.dialogRef.close(false);
  }

  public onTrueClick(): void {
    this.dialogRef.close(true);

    if (this.showNummericInput) {
      this.dialogRef.close(this.nummericValue);
    }
    else {
      this.dialogRef.close(true);
    }
  }

  public onSliderInput(value: number): void {
    this.nummericValue = value;
  }

  public onSliderChange(value: number): void {
    this.nummericValue = value;
  }

  public setMessageInfo(message: string): void{
    this.message = message;
    this.cdr.markForCheck();
  }
}
